import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarList: 'configuration',
  globalLoading: false,
  showSidebar: false,
  showBelvoWidget: false,
  belvoParameters: { integrationStartDate: new Date().toISOString() }
};

export const UISlice = createSlice({
  name: 'UI',
  initialState,
  reducers: {
    setValues: (state, action) => {
      Object.keys(action.payload).forEach(key => {
        state[key] = action.payload[key];
      });
    },
    setLoading: (state, action) => {
      state.globalLoading = action.payload;
    }
  }
});

export const { setValues, setLoading } = UISlice.actions;
export default UISlice.reducer;
